<template>
  <div class="activity-box">
    <div class="main">
      <img class="bg" src="./images/bg.png" alt="" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'ActivityBox',
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {}
};
</script>
<style lang="scss" scoped>
.activity-box {
  width: 100%;
  background-color: #010119;
  background-image: url('./images/web-bg.jpg');
  background-size: 100% 100%;
  overflow: auto;
  text-align: center;
  font-size: 0;
  .main {
    position: relative;
    display: inline-block;
    width: 750px;
    text-align: left;
    > .bg {
      width: 100%;
    }
  }
}
</style>
